/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyDetailViewModel } from "../types/AssociatedCompanyDetailViewModel.ts";
import { associatedCompanyAddressViewModelSchema } from "./associatedCompanyAddressViewModelSchema.ts";
import { eAssociateCompanyTotalEmployeesSchema } from "./eAssociateCompanyTotalEmployeesSchema.ts";
import { eAssociatedCompanyStatusSchema } from "./eAssociatedCompanyStatusSchema.ts";
import { eCompanySizeSchema } from "./eCompanySizeSchema.ts";

export const associatedCompanyDetailViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  name: z.string().nullish(),
  tradeName: z.string().nullish(),
  document: z.string().nullish(),
  stateRegistration: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  contact: z.string().nullish(),
  status: z.optional(
    z
      .lazy(() => eAssociatedCompanyStatusSchema)
      .describe("1 = Associated | 2 = InProcess | 3 = NotAssociated | "),
  ),
  statusDescription: z.string().nullish(),
  partnershipDateStart: z.string().datetime().nullish(),
  partnershipDateEnd: z.string().datetime().nullish(),
  partnerId: z.number().int().nullish(),
  partnerDescription: z.string().nullish(),
  discountTypeId: z.number().int().nullish(),
  discountTypeDescription: z.string().nullish(),
  poloId: z.number().int().nullish(),
  poloName: z.string().nullish(),
  responsiblePersonId: z.number().int().nullish(),
  responsiblePersonName: z.string().nullish(),
  validateEmail: z.optional(z.boolean()),
  validateCpf: z.optional(z.boolean()),
  validateDomain: z.optional(z.boolean()),
  validateDocumentation: z.optional(z.boolean()),
  domain1: z.string().nullish(),
  domain2: z.string().nullish(),
  domain3: z.string().nullish(),
  domain4: z.string().nullish(),
  domain5: z.string().nullish(),
  occupationArea: z.string().nullish(),
  companySize: z.optional(
    z
      .lazy(() => eCompanySizeSchema)
      .describe(
        "1 = MEI | 2 = ME | 3 = EPP | 4 = LTDA | 5 = SA | 6 = NotApplicable | ",
      ),
  ),
  companySizeDescription: z.string().nullish(),
  totalEmployees: z.optional(
    z
      .lazy(() => eAssociateCompanyTotalEmployeesSchema)
      .describe(
        "1 = From0To50 | 2 = From50To100 | 3 = From100To500 | 4 = From500To1000 | 5 = HigherThan1000 | ",
      ),
  ),
  totalEmployeesDescription: z.string().nullish(),
  notListed: z.optional(z.boolean()),
  hideFinancialData: z.optional(z.boolean()),
  companyId: z.number().int().nullish(),
  active: z.optional(z.boolean()),
  inactiveDate: z.string().datetime().nullish(),
  peopleCount: z.optional(z.number().int()),
  attachmentFileName: z.string().nullish(),
  attachmentUrl: z.string().nullish(),
  address: z.optional(z.lazy(() => associatedCompanyAddressViewModelSchema)),
  userCreation: z.string().nullish(),
  creationDate: z.string().datetime().nullish(),
  userLastChange: z.string().nullish(),
  lastChangeDate: z.string().datetime().nullish(),
}) as unknown as ToZod<AssociatedCompanyDetailViewModel>;
